import { Fragment, CSSProperties, useCallback } from 'react';
import moment from 'moment';
import i18n from 'i18next';
import { Device } from 'shared/models';
import { useSelector } from 'react-redux';
import { getDeviceTypeNamesLookup } from 'selectors/deviceTypesSelectors';
import { useTranslation } from 'react-i18next';
import { DeviceStatus } from 'ui/shared/deviceStatus';
import { Link } from 'react-router-dom';
import { useParams } from 'util/reactRouterHooks';
import { HasUrlSlug, HasDeviceId, HasDevicePage } from 'selectors/buildingsSelectors';
import { ScheduleColumn } from './scheduleColumn';

require('./DeviceTreeDeviceNode.css');

const halfOpacity: CSSProperties = {
    opacity: .5,
};

const NeverCheckedIn = () => {
    const { t } = useTranslation();
    return (
        <span style={ halfOpacity }>
            { t('DEVICES.NEVER_CHECKED_IN') }
        </span>
    );
};

export type Props = {
    id: string;
    label: string;
    depth: number;
    device: Device;
    onClickSchedule(id: string): void;
};

export const DeviceTreeDeviceNode = ({ id, label, depth, device, onClickSchedule }: Props) => {
    const { urlSlug, deviceId, devicePage = 'status' } = useParams<HasUrlSlug & HasDeviceId & HasDevicePage>();

    const deviceTypeNameMap = useSelector(getDeviceTypeNamesLookup);
    const handleClickSchedule = useCallback(() => onClickSchedule(id), [ onClickSchedule, id ]);

    const {
        deviceTypeId = '',
        lastCheckIn = '',
        status = '',
        ipAddress = '',
        deviceClass = 'unknown',
    } = device || {};

    const when = lastCheckIn && moment(lastCheckIn).locale(i18n.language);

    return (
        <Fragment>
            <div
                key={ id }
                className={ `device-node label depth-${depth} ${device.id === deviceId ? 'active' : ''}` }
            >
                <div className="status">
                    <DeviceStatus status={ status }/>
                </div>
                <Link
                    className="name"
                    to={ `/buildings/${urlSlug}/devices/${device.id}/${devicePage}` }
                    draggable={ false }
                >
                    { label }
                </Link>
                <div className="device-type">
                    { deviceTypeNameMap[deviceTypeId] }
                </div>
            </div>
            <div className="schedule">
                { deviceClass === 'display' &&
                    <ScheduleColumn deviceId={ id } onClick={ handleClickSchedule }/>
                }
            </div>
            <div className="last-check-in">
                { when
                    ? <span title={ when.format('LLLL') }>{ when.fromNow() }</span>
                    : <NeverCheckedIn/>
                }
            </div>
            <div className="ip-address">
                { ipAddress }
            </div>
        </Fragment>
    );
};
